/**
 * Make the md-button better adding loading capability
 */
(function() {
    'use strict';
    angular.module('emarket.commons').directive('emButton', function() {
        return {
            templateUrl: 'directives/em-button/em-button.tpl.html',
            transclude: true,
            scope: {
                isLoading: '=',
                loadingText: '=',
                type: '=?',
                disabled: '=?'
            },
            controller: [
                '$rootScope',
                '$scope',
                function($rootScope, $scope) {
                    var ev = $rootScope.$on('emarket:loading:enable', function() {
                        $scope.$apply(function() {
                            $scope.isLoading = false;
                        });
                    });

                    $scope.$on('$destroy', function() {
                        ev();
                    });
                }
            ],
            link: function(scope, element, attrs) {
                scope.type = attrs.type || 'button';
                scope.classes = attrs.class;
                if (element.hasClass('md-icon-button')) {
                    element.addClass('em-button--no-text');
                }
                scope.$watch(function() {
                    return scope.isLoading;
                },
                function() {
                    if (scope.isLoading) {
                        element.addClass('is-loading');
                    } else {
                        element.removeClass('is-loading');
                    }
                });
                element.addClass('em-button');
            }
        };
    });
}());
